import React from 'react';
import { QuestionCategory } from '../../types/qa';

interface CategoryFilterProps {
  selectedCategory: QuestionCategory | 'all';
  onSelect: (category: QuestionCategory | 'all') => void;
}

const categories: Array<{ value: QuestionCategory | 'all'; label: string }> = [
  { value: 'all', label: 'All Questions' },
  { value: 'medical', label: 'Medical' },
  { value: 'dating', label: 'Dating' },
  { value: 'relationships', label: 'Relationships' },
  { value: 'support', label: 'Support' },
  { value: 'general', label: 'General' }
];

export function CategoryFilter({ selectedCategory, onSelect }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map(({ value, label }) => (
        <button
          key={value}
          onClick={() => onSelect(value)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-colors
            ${selectedCategory === value
              ? 'bg-primary-500 text-white'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
            }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}